import { Component, OnInit, } from '@angular/core';

@Component({
    selector: 'popup-loader',
    templateUrl: 'popup-loader.component.html',
    styleUrls: ['./popup-loader.component.scss'],
    standalone: false
})
export class PopupLoader implements OnInit {
	ngOnInit(){}
}
